export const sxStyled = theme => ({
  submitContainer: {
    mt: theme.spacing(3),
    width: '100%',
    px: { xs: theme.spacing(2) },
  },

  submitButton: {
    bgcolor: 'green',
    color: 'white',
    '&:hover': {
      bgcolor: 'darkgreen',
    },
  },

  submitMargin: {
    mb: theme.spacing(2),
  },
});
